<!-- #18 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Upload Billing data
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="mt-2">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Upload

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <v-card dense flat>
            <v-card-text class="pb-0">
              <ul class="text-left mb-2">
                <li>Upload Billing data for orders chargeable by Carrier</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col class="pb-0">
                <v-select
                  label="carrier"
                  :rules="[(v) => !!v || 'carrier is required.']"
                  class="required pt-0 pb-0 mt-0"
                  v-model="selectedcarrier"
                  :items="carriers"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  @input="fetchcarrierList()"
                  outlined
                ></v-select>
              </v-col>

              <v-col :md="clientNeeded == 1 ? '4' : '6'" class="custom pb-0">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select your packages file"
                  class="required pb-0"
                  outlined
                  :rules="[(v) => !!v || 'Please select Packages File']"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                  v-if="
                    checkPermission(
                      'app_carrier_partner:carrier_consignment_billing_upload'
                    )
                  "
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: { BulkErrors },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  mounted() {
    this.$nextTick(() => {});
  },
  data() {
    return {
      carriers: [],
      file: null,
      fileLoader: false,
      downloader: false,
      uploadRes: {},
      uploadResDialog: false,
      selectedcarrier: "",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchPackage();
      },
      deep: true,
    },
    search() {
      this.fetchPackage();
    },
    searchType() {
      if (this.search) this.fetchPackage();
    },
  },

  created() {
    this.fetchcarrierList();
  },

  methods: {
    ...mapActions([
      "getCarriersDropdown",
      "snackBar",
      "uploadBillingData",
      "downloadBillingTemplate",
    ]),
    close() {
      this.$refs.form.reset();
    },
    fetchcarrierList() {
      if (this.carriers.length == 0) {
        this.getCarriersDropdown({
          pagination: 0,
          active: "all",
        }).then((res) => {
          this.carriers = res.data;
        });
      }
    },

    downloadTemplate() {
      this.downloader = true;
      this.downloadBillingTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      payload.append("carrier_id", this.selectedcarrier);

      this.uploadBillingData(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          // this.snackBar({
          //   color: "success",
          //   message: res.data.message,
          // });
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },
  },
};
</script>
<style>
.file-padding {
  padding-right: 72px;
}
.custom .v-text-field {
  padding-top: 0;
}
</style>
